import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { domainUrl } from '../../../constants'
import { message } from 'antd'


export const getAllTeam = createAsyncThunk('getTeamStatistics',
    async (object, { dispatch, getState }) => {
        dispatch(gettingTeamDetail())
        var myHeaders = new Headers();
        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow',
        };
        fetch(domainUrl + `/viewAllTeams`, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result?.success) {
                    dispatch(teamDetailResponse(result?.data))
                }
                else 
                    throw result?.message
            })
            .catch(error => { 
                dispatch(teamDetailClear())
                message.error(error) 
            })
    }
)



const TeamGetSlice = createSlice({
    name: 'ourTeamapi',
    initialState: {
        teamData: null,
        loadingteamDetail: false,
    },
    reducers: {
        gettingTeamDetail: state => {
            state.loadingteamDetail=true
            state.teamData=null
        },
        teamDetailResponse: (state, action)=>{
            state.teamData= action.payload
            state.loadingteamDetail= false
        },
        teamDetailClear: (state)=>{
            state.teamData= null
            state.loadingteamDetail= false
        },
    },
})
export const { 
    gettingTeamDetail, teamDetailResponse, teamDetailClear
} = TeamGetSlice.actions;
export default TeamGetSlice.reducer;